export default __webpack_public_path__ + "static/media/lg-d.aa30a088.jpg";